
function urlrequire(url, callback) {
    var e = document.createElement("script");
    e.src = url;
    e.type = "text/javascript";
    e.addEventListener('load', callback);
    document.getElementsByTagName("head")[0].appendChild(e);
}

export function googlemaps() {
    if ($jq3('.property-maps').length && typeof mapsKey !== 'undefined') {
        $jq3('.property-maps .consent-request').remove();
        const query = $jq3('.property-maps').data('map-query');
        $jq3('.property-maps').append('<iframe class="google-maps-iframe" title="maps-iframe" frameborder="0" style="border:0" src="https://www.google.com/maps/embed/v1/place?key=' + mapsKey + '&amp;q=' + query + '" allowfullscreen=""></iframe>');
    }

    if ($jq3('.marked-maps').length) {
        $jq3('.marked-maps .consent-request').remove();
        urlrequire("https://maps.googleapis.com/maps/api/js?key=" + "AIzaSyAyq1SsOS6erXepP44SOJ2tV5GcKU7y-qI", function () {

            $jq3('.marked-maps').append('<div id="markedmap" style="width:100%;height:100%;"></div>');

            const icon = {
                path: "M17.87,0A17.89,17.89,0,0,0,0,17.87C0,27.35,16.21,49.5,16.9,50.44l.64.88a.39.39,0,0,0,.33.16.39.39,0,0,0,.32-.16l.64-.88c.69-.94,16.9-23.09,16.9-32.57A17.89,17.89,0,0,0,17.87,0Zm0,11.47a6.4,6.4,0,1,1-6.41,6.4,6.41,6.41,0,0,1,6.41-6.4Zm0,0",
                fillColor: '#FFFFFF',
                fillOpacity: 1,
                strokeColor: '#0275bb',
                strokeOpacity: 1,
                anchor: new google.maps.Point(0, 0),
                scale: .75
            }


            const map = new google.maps.Map(document.getElementById('markedmap'), {
                zoom: 11,
                center: mapCenter
            });

            let bounds = new google.maps.LatLngBounds();

            mapsMarker.forEach(function (passedMarker) {
                const marker = new google.maps.Marker({
                    position: passedMarker.latlng,
                    map: map,
                    icon: icon
                });

                bounds.extend(marker.position);

                marker.addListener('click', function () {
                    window.location.href = passedMarker.link;
                });
            });

            map.fitBounds(bounds);
        });
    }
}